import { defineStore } from 'pinia';
import { state } from "@/store/learning/assessment/state";
import { assessmentGetters } from "@/store/learning/assessment/getters";
import { assessmentActions } from "@/store/learning/assessment/actions";

export { type LearningAssessmentStoreState } from "@/store/learning/assessment/state";
export { type LearningAssessmentStoreGetters } from "@/store/learning/assessment/getters";

export const useLearningAssessmentStore = defineStore('learningAssessmentStore', {
    state,
    getters: assessmentGetters,
    actions: assessmentActions
});
